import { usePostManagement } from "../hooks/usePostManagement";
import {
  LoadingSpinner,
  PostManagementHeader,
  CategoryManager,
  PostList,
} from "./post";
import { MultiLanguageCategoryForm } from "./post/MultiLanguageCategoryForm";

export const PostManagement = () => {
  const {
    posts,
    categories,
    loading,
    showCategoryForm,
    showCategoryEditForm,
    editingCategory,
    handleDeletePost,
    handleCreateCategory,
    handleUpdateCategory,
    handleEditCategory,
    handleDeleteCategory,
    openNewCategoryForm,
    setShowCategoryForm,
    setShowCategoryEditForm,
  } = usePostManagement();

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="p-6 overflow-y-auto max-h-screen box-border">
      <PostManagementHeader onNewCategory={openNewCategoryForm} />

      <CategoryManager
        categories={categories}
        onDeleteCategory={handleDeleteCategory}
        onEditCategory={handleEditCategory}
      />

      <MultiLanguageCategoryForm
        isOpen={showCategoryForm}
        onClose={() => setShowCategoryForm(false)}
        onSubmit={handleCreateCategory}
      />

      <MultiLanguageCategoryForm
        category={editingCategory}
        isOpen={showCategoryEditForm}
        onClose={() => setShowCategoryEditForm(false)}
        onSubmit={(translations, key, icon, color) =>
          handleUpdateCategory(
            editingCategory!.id,
            translations,
            key,
            icon,
            color
          )
        }
      />

      <PostList posts={posts} onDeletePost={handleDeletePost} />
    </div>
  );
};
